import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetChatCommunicationQuery = (type, page = 1, limit = 20) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_CHAT_COMMS, type, page, limit],
    queryFn: () => api.get(API_ROUTES.GET_CHAT_COMMS, { params: { type, page, limit } }),
    enabled: !!type,
  });
  return { 
    data: data?.data?.data ?? [], 
    pagination: data?.data?.pagination,
    isPending, 
    isError, 
    error 
  };
};

export const useAnalyzeChatConversationMutation = () => {
  const queryClient = useQueryClient();
  const {
    mutate,
    data,
    isPending,
    isError,
    error,
    isSuccess
  } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.ANALYZE_CHAT_CONVERSATION, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries([API_ROUTES.GET_CHAT_COMMS]);
      console.log('Analysis completed successfully:', data);
    },
    onError: (error) => {
      console.error('Error analyzing chat conversation:', error);
    }
  });
  
  return { mutate, data, isPending, isError, error, isSuccess };
};

export const useGenerateUpdatedPromptMutation = () => {
  const queryClient = useQueryClient();
  const {
    mutate,
    data,
    isPending,
    isError,
    error,
    isSuccess,
    reset
  } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.GENERATE_UPDATED_PROMPT, payload),
    onSuccess: (data) => {
      // invalidate and refetch
      queryClient.invalidateQueries([API_ROUTES.GET_CHAT_COMMS]);

    }
  });
  
  return { mutate, data, isPending, isError, error, isSuccess, reset };
};

export const useSuggestImprovementMutation = () => {
  const { mutate, data, isPending, isError, error, isSuccess, reset } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.SUGGEST_IMPROVEMENT, payload),
  });
  return { mutate, data, isPending, isError, error, isSuccess, reset };
};

export const useApplyImprovementMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, data, isPending, isError, error, isSuccess } = useMutation({
    mutationFn: (payload) => api.post(API_ROUTES.APPLY_IMPROVEMENT, payload),
    onSuccess: () => {
      queryClient.invalidateQueries([API_ROUTES.GET_CHAT_COMMS]);
    },
  });
  return { mutate, data, isPending, isError, error, isSuccess };
};

export const useGetVendorQuestionsQuery = (page = 1, limit = 50) => {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: [API_ROUTES.GET_VENDOR_QUESTIONS, page, limit],
    queryFn: () => api.get(API_ROUTES.GET_VENDOR_QUESTIONS, { params: { page, limit } }),
  });
  return {
    data: data?.data?.data ?? [],
    pagination: data?.data?.pagination,
    isPending,
    isError,
    error,
    refetch,
  };
};

export const useGetChatHistoryQuery = (chatId, page = 1, limit = 50) => {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: [API_ROUTES.GET_CHAT_HISTORY, chatId, page, limit],
    queryFn: () => api.get(`${API_ROUTES.GET_CHAT_HISTORY}/${chatId}`, { params: { page, limit } }),
    enabled: !!chatId,
    staleTime: 30 * 1000, // 30s
  });
  return {
    data: data?.data?.data ?? [],
    pagination: data?.data?.pagination,
    isPending,
    isError,
    error,
    refetch,
  };
};
